import { PricingMeta } from 'components/Pricing/Pricing.types';

export const isPriceLocalized = (
  price: number,
  pricePoints: PricingMeta[]
) => {
  return !!pricePoints.find(
    (p: PricingMeta) => p.priceInCents === price
  );
};
